module.exports = __webpack_public_path__ + "static/floorplan_06-fb891f35438c3d4008fa92794b7af79c.jpg";